import React, { useRef, useMemo } from "react";


import CustomField from "components/Form/CustomField";
import HiddenRate from "./HiddenRate";

import { FlexboxGrid, Form, InputNumber, Schema, SelectPicker } from "rsuite";

const { NumberType } = Schema.Types;


export default ({
    defaultFormValue,
    onChangeForm,
    formValue,
    disabled,
    subdestination_list
}) => {

    let formRef = useRef(null);

    const numbersList = useMemo(() => {
        const prefixCount = 0;
        const difference = 6 - prefixCount > 0 ? 6 - prefixCount : 1;

        const numberArray = Array.from(Array(difference).keys());
        return numberArray.map(x => 10 ** x).map(x => ({ label: x, value: +x }));

    }, [formValue]);


    const currentSubdest = useMemo(() =>
        subdestination_list.find(subdest => subdest.sde_key === formValue.sde_key) || [null]
        , [formValue]);

    const formModel = Schema.Model({
        sde_key: NumberType()
            .isRequired("Required"),
        prefixes: NumberType()
            .min(1, "Minimum is 1")
            .max(currentSubdest.max_prefix_digits, `Maximum is ${currentSubdest.length}`)
            .isRequired("Required"),
        numbers: NumberType()
            .isRequired("Required"),
    });

    return (
        <Form
            defaultFormValue={defaultFormValue}
            onChange={onChangeForm}
            formModel={formModel}
            formValue={formValue}
            ref={formRef}
        >
            <FlexboxGrid justify="start" style={{ margin: "0 0 20px 0" }}>
                <FlexboxGrid.Item>
                    <Form.ControlLabel>Template</Form.ControlLabel>
                    <CustomField
                        disabled={disabled}
                        placeholder="123456XX"
                        errorPlacement="topRight"
                        name="template"
                        style={{ width: 230 }}
                    />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item className="ml-4">
                    <Form.ControlLabel>Prefix count</Form.ControlLabel>
                    <Form.Control
                        disabled={disabled}
                        accepter={InputNumber}
                        name="prefixes"
                        placeholder="Prefixes"
                        style={{ width: 230 }}
                        min={1}
                        max={currentSubdest.max_prefix_digits - 1}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>

            <FlexboxGrid justify="start" style={{ margin: "0 0 20px 0" }}>
                <FlexboxGrid.Item>
                    <Form.ControlLabel>Numbers</Form.ControlLabel>
                    <Form.Control
                        disabled={disabled || !formValue?.prefixes}
                        accepter={SelectPicker}
                        data={numbersList}
                        name="numbers"
                        labelKey="label"
                        valueKey="value"
                        placeholder="Numbers"
                        style={{ width: 230 }}
                        searchable={false}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>

            <br />
            <HiddenRate />

        </Form>
    );
};